module.exports = __webpack_public_path__ + "static/img/beta_bg_05.ce83f217.svg";